import React, { useCallback, useEffect, useState } from "react";
import { Button, Form, Nav, Modal } from "react-bootstrap";
import { FaRegSquarePlus } from "react-icons/fa6";
import { IoDownloadOutline } from "react-icons/io5";
import { MdOutlineFolderZip } from "react-icons/md";
import { IconContext } from "react-icons";
import * as yup from "yup";
import { useFormik } from "formik";
import toast from "react-hot-toast";
import moment from "moment";
import CustomisedModal from "../../components/Modal/CustomisedModal";
import sampleFile from "../../assets/files/sample-sheet.xlsx";
import sampleImageFile from "../../assets/files/images.zip";
import filtericon from "../../assets/images/Filter.png";
import { Paper, Switch, Tooltip } from "@mui/material";
import { CircularProgress, Grid } from "@mui/material";
import DataTable from "react-data-table-component";
import deleteIcon from "../../assets/images/delete.png";
import editIcon from "../../assets/images/edit.png";
import {
  createPromoCodes,
  deletePromoCode,
  editPromoCodes,
  getActivePromocodesCount,
  getActivePromocodesListing,
  getInActivePromocodesCount,
  getInActivePromocodesListing,
  getPromocodesListing,
  statusPromoCodeUpdate,
} from "../../api/context/promocodes";
import { getSubCategoryListing } from "../../api/context/subcategory";
import { getCategoryListing } from "../../api/context/category";
import Loader from "../../components/loader/loader";
import { checkUserPermissions } from "../../helpers/permission";
import { useNavigate } from "react-router";
import {
  deleteProduct,
  getProductsListing,
  getProductsLowStockListing,
  getProductsOutStockListing,
  getProductsVariants,
  statusProductUpdate,
  uploadBulkImage,
  uploadBulkProducts,
} from "../../api/context/products";
import Variant from "./Variant";
import { RiArrowDownSLine } from "react-icons/ri";
import { FaCloudUploadAlt } from "react-icons/fa";
import { Box } from "@material-ui/core";
import { MdOutlineNotifications, MdOutlineUploadFile } from "react-icons/md";
import { getCategoryListingPaginate, getManufacturesListingPaginate, getStoresListing, getSubCategoryListingPaginate } from "../../api/context/manufacturer";
import { IoSearchOutline } from "react-icons/io5";
import { useRecoilState } from "recoil";
import { inventoryListFilter } from "../../atoms/inventoryListFIlter";
import AsyncSelect from 'react-select/async';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { getBrandListing } from "../../api/context/brand";
import { Spinner } from "reactstrap";
import { FiTrash2 } from "react-icons/fi";

const queueDatatableCustomStyles = {
  header: {
    style: {
      fontWeight: '600',
      fontSize: '22px',
      color: '#000',
    },
  },
  headCells: {
    style: {
      display: "flex",
      justifyContent: "center",
      fontWeight: '600',
      fontSize: '14px',
      padding: '16px 8px',
      backgroundColor: '#f9f9f9ff',
    },
  },
  cells: {
    style: {
      display: "flex",
      // justifyContent: "center",
      fontSize: '12px',
      fontWeight: '500',
      padding: '12px',
    },
  },

};

const Inventory = () => {
  const navigate = useNavigate();

  const user = JSON.parse(localStorage.getItem("user"));

  const [filterData, setFilterdata] = useRecoilState(inventoryListFilter);
  // const [page, setPage] = useRecoilState(orderListPage);
  // const [limit, setLimit] = useRecoilState(orderListLimit);

  const [show, setShow] = useState(false);
  const [showImage, setShowImage] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [totalExpandedRows, setTotalExpandedRows] = useState(0);
  const [totalActiveRows, setTotalActiveRows] = useState(0);
  const [totalInActiveRows, setTotalInActiveRows] = useState(0);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [limitactive, setLimitActive] = useState(10);
  const [pageactive, setPageActive] = useState(1);
  const [limitinactive, setLimitInactive] = useState(10);
  const [pageinactive, setPageInactive] = useState(1);
  const [limitvariant, setLimitVariant] = useState(10);
  const [pagevariant, setPageVariant] = useState(1);
  const [update, setUpdate] = useState(false);
  const [updateoutstock, setUpdateOutStock] = useState(false);
  const [updatelowstock, setUpdateLowStock] = useState(false);
  const [activedata, setActiveData] = useState([]);
  const [inactivedata, setInActiveData] = useState([]);
  const [category, setCategory] = useState([]);
  const [subcategory, setSubCategory] = useState([]);
  const [search, setSearch] = useState("");
  const [data, setData] = useState([]);
  const [variantdata, setVariantData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [defaultLoading, setDefaultLoading] = useState(false);
  const [loadingnested, setLoadingNested] = useState(false);
  const [initial, setInitial] = useState(false);
  const [filter, setFilter] = useState("all");
  const [bulkLoading, setBulkLoading] = useState(false);
  const [expandedRows, setExpandedRows] = useState([]);
  const [store, setStore] = useState([]);

  // Inside your component
  const [modal, setModal] = useState(false);
  const [deletingId, setDeletingId] = useState("");
  const [showOff, setShowOff] = useState(false);
  const [brands, setBrands] = useState([]);
  const [manufacturers, setManufacturers] = useState([]);

  const [pagebrands, setPageBrands] = useState(1); // Current page for API pagination
  const [hasMore, setHasMore] = useState(true); // To track if more data is available

  const [pagemanufacture, setPageManufacture] = useState(1);
  const [hasMoreManufacture, setHasMoreManufacture] = useState(true);

  const [enableBulkInventory, setEnableBulkInventory] = useState(false);

  const handleCloseOff = () => setShowOff(false);
  const handleShowOff = () => setShowOff(true);
  const stockViewOptions = [
    { value: "all", label: "All" },
    { value: "active", label: "Out of Stock" },
    { value: "inactive", label: "Low Stock" },
  ];


  const orderTypeOptions = [
    { value: null, label: 'NEW' },
    { value: 1, label: 'RETURN' },
    { value: 2, label: 'EXCHANGE' },
    { value: 3, label: 'DELIVERED' },
  ]

  const paymentModeOptions = [
    { value: "COD", label: 'COD' },
    { value: "ONLINE", label: 'ONLINE' },
  ]

  const toggleModal = () => {
    setModal(!modal);
  };

  const handleShow = () => {
    setShow(true);
    setEnableBulkInventory(false);
  }

  const handleClose = () => {
    bulkFormikProduct.resetForm();
    setShow(false);
  };

  const handleShowImage = () => setShowImage(true);

  const handleCloseImage = () => {
    bulkFormikImage.resetForm();
    setShowImage(false);
  };

  const columns = [
    {
      name: "S. No.",
      selector: (row, index) => {
        if (filter === "all") {
          return page * limit - limit + (index + 1);
        } else if (filter === "active") {
          return pageactive * limitactive - limitactive + (index + 1);
        } else if (filter === "inactive") {
          return pageinactive * limitinactive - limitinactive + (index + 1);
        } else {
          return page * limit - limit + (index + 1);
        }
      },
      center: true,
      width: "90px",
      cell: (row, index) => (
        <div className="text-center">
          {filter === "all"
            ? page * limit - limit + (index + 1)
            : filter === "active"
              ? pageactive * limitactive - limitactive + (index + 1)
              : pageinactive * limitinactive - limitinactive + (index + 1)
          }
        </div>
      ),
    },
    {
      id: "productname",
      name: "Product Name",
      selector: (row) => row?.productName,
      cell: (row) => (
        <div
          className="related-order-box  text-truncate"
          style={{

            color: 'black',
            padding: '4px 8px',
            borderRadius: '4px',
            fontWeight: '500',
            cursor: 'pointer',
            minWidth: '80px',
            textAlign: 'center',
            margin: '2px',

          }}
          onClick={(e) => {
            e.stopPropagation();
            navigate("/edit-inventory/" + row.id);
          }}
        >
          <Tooltip title={row?.productName} disableInteractive placement="top">
            <span>{row?.productName}</span>
          </Tooltip>
        </div>
      ),
      width: "180px",
      center: true,
    },

    {
      id: "colors",
      name: "Colors",
      selector: (row) => row?.color,
      cell: (row) => (
        <div className="d-flex justify-content-center">
          <div
            className="color_code"
            style={{
              width: "20px",
              height: "20px",
              border: "1px solid #EBEBEB",
              borderRadius: "50%",
              boxShadow: "0 0 12px -1px rgba(0, 0, 0, .11)",
              backgroundColor: row.color,
            }}
          ></div>
        </div>
      ),
      width: "90px",
      center: true,
    },

    (user?.userType === "ADMIN") ?

      {
        id: 'storeName',
        name: 'Store',
        selector: (row) => row?.manufacturer?.storeName,
        cell: (row) => {
          const platform = row?.manufacturer?.externalPlatform?.toLowerCase();

          const platformData = {
            'woocommerce': { initial: 'W', color: '#96588a' },
            'shopify': { initial: 'S', color: '#5e8e3e' },
            'magento': { initial: 'M', color: '#f46f25' },
          };

          const platformInfo = platformData[platform];

          return (
            <div
              className="d-flex align-items-center justify-content-center"
              style={{
                width: '100%',
                cursor: 'pointer',
                padding: '6px 8px',
                gap: '8px',
                minWidth: 0,
                textDecoration: 'underline',
                textUnderlineOffset: '2px',
                textDecorationThickness: '1px',
                textDecorationColor: '#a94b4bff',
              }}
              onClick={() => navigate('/edit-vendors/' + row?.manufacturer?.id)}
            >
              {platformInfo && (
                <div
                  style={{
                    flexShrink: 0,
                    width: '20px',
                    height: '20px',
                    borderRadius: '4px',
                    color: platformInfo.color,
                    border: `1px solid ${platformInfo.color}`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '12px',
                    fontWeight: 'bold',
                  }}
                >
                  {platformInfo.initial}
                </div>
              )}
              <Tooltip title={row?.manufacturer?.storeName} disableInteractive placement="top">
                <div
                  style={{
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    minWidth: 0,
                  }}

                >
                  {row?.manufacturer?.storeName}
                </div>
              </Tooltip>
            </div>
          );
        },

        sortable: true,
        width: '200px',
        center: true,
      } : { width: '0px', },

    {
      id: "category",
      name: "Category",
      selector: (row) => row?.productSubcategory?.title,
      cell: (row) => {
        const category = row?.productSubcategory?.title?.toLowerCase();
        let bgColor = '';
        let textColor = 'white';

        if (category?.includes('men')) {
          bgColor = '#5282ceff'; // Blue for men
        } else if (category?.includes('woman')) {
          bgColor = '#ec4899'; // Pink for women
        } else if (category?.includes('kid')) {
          bgColor = '#22c55e'; // Green for kids
        } else {
          bgColor = 'gray';
          textColor = 'black';
        }

        return (
          <div className="text-center">
            {row?.productSubcategory?.title ? (
              <Tooltip title={row?.productSubcategory?.title} disableInteractive placement="top">
                <span
                  style={{
                    backgroundColor: bgColor,
                    color: textColor,
                    padding: '4px 8px',
                    borderRadius: '4px',
                    fontWeight: '500',
                    display: 'inline-block',
                    maxWidth: '100%',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                  }}
                >
                  {row.productSubcategory.title}
                </span>
              </Tooltip>
            ) : (
              'N/A'
            )}
          </div>
        );
      },
      width: "100px",
      center: true,
    },
    {
      id: "price",
      name: "Price",
      selector: (row) => row?.price,
      cell: (row) => (
        <div className="text-center text-truncate">{row?.price}</div>
      ),
      width: "100px",
      center: true,
    },
    {
      id: "discount",
      name: "Discounted",
      selector: (row) => row?.discountedPrice,
      cell: (row) => (
        <div className="text-center text-truncate">{row?.discountedPrice}</div>
      ),
      width: "100px",
      center: true,
    },
    {
      id: "stock",
      name: "Stock",
      selector: (row) => row?.stock,
      cell: (row) => (
        <div
          className="text-center text-truncate"
          style={{
            fontWeight: row?.stock <= 0 ? 'bold' : 'semibold',
            color: row?.stock <= 0 ? '#dc3545' : 'inherit'
          }}
        >
          {row?.stock <= 0 ? '0' : row?.stock}
        </div>
      ),
      width: "90px",
      center: true,
    },

    // {
    //   name: "Status",
    //   selector: (row) => row.status,
    //   cell: (row, index) => (
    //     <div className="d-flex justify-content-center">
    //       <Switch
    //         size="20px"
    //         id={`custom-switch-${index}`}
    //         checked={row?.isActive}
    //         onChange={() => statusActive(row?.id, row?.isActive, index)}
    //         className="custom-switch"
    //       />
    //     </div>
    //   ),
    //   sortable: true,
    //   center: true,
    //   width: "150px",
    // },

    {
      id: "action",
      name: "Actions",
      cell: (row, index) => (
        <div className="d-flex justify-content-center">
          {checkUserPermissions("manage_products") ? (
            <div className="d-flex align-items-center">
              <div className="d-flex flex-row align-items-center gap-3" role="button">
                <div className="d-flex justify-content-center">
                  <Switch
                    size="20px"
                    id={`custom-switch-${index}`}
                    checked={row?.isActive}
                    onChange={() => statusActive(row?.id, row?.isActive, index)}
                    className="custom-switch"
                  />
                </div>

                <Tooltip title="Delete" disableInteractive placement="top">
                  <div className="delete_icon_bg" onClick={() => handleConfirm(row?.id)}>
                    <FiTrash2 className="delete_icon text-black fs-5" />
                  </div>
                </Tooltip>
                <RiArrowDownSLine
                  className="down_arrow_icon"
                  onClick={() => handleRowExpand(row)}
                />
              </div>
            </div>
          ) : (
            <></>
          )}
        </div>
      ),
      center: true,
      width: "200px",
    },
  ];

  const conditionalRowStyles = [
    {
      when: row => row.stock <= 0,
      style: {
        backgroundColor: 'rgba(238, 145, 155, 0.1)', // Very light red
        '&:hover': {
          backgroundColor: 'rgba(238, 145, 155, 0.1)' // Slightly darker on hover
        }
      },
    },
  ];


  const searchFormik = useFormik({
    initialValues: {
      brands: filterData.brands || [],
      selected_brands: filterData.selected_brands || [],
      vendors: filterData.vendors || [],
      selected_vendors: filterData.selected_vendors || [],
      subCategory: filterData.subCategory || [],
      selectedCategory: filterData.selectedCategory || [],
      subSubCategory: filterData.subSubCategory || [],
      selectedSubCategory: filterData.selectedSubCategory || [],
    },
    validate: async (values) => {
      // Add validation logic if needed
    },
    onSubmit: (values, { resetForm }) => {
      setLoading(true);
      setFilterdata(values);
      setShowOff(false);
    },
  });



  const handleExcelFileChange = (event) => {
    const file = event.currentTarget.files[0];
    const supportedFormats = [
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'text/csv'
    ];

    if (file && !supportedFormats.includes(file.type)) {
      toast.error('Unsupported file format. Please upload an Excel file.');
      return;
    }
    bulkFormikProduct.setFieldValue('excelFile', file);
  };


  const handleImageZipChange = (event) => {
    const file = event.currentTarget.files[0];
    if (file && !file.type.includes('zip') && !file.name.endsWith('.zip')) {
      toast.error('Please upload a valid ZIP file.');
      return;
    }
    bulkFormikProduct.setFieldValue('imageZip', file);
  };

  const bulkFormikProduct = useFormik({
    initialValues: {
      excelFile: null,
      imageZip: null
    },
    validationSchema: yup.object().shape({
      excelFile: yup
        .mixed()
        .required("Excel file is required")
        .test(
          "fileFormat",
          "Unsupported file format",
          (value) => value && [
            'application/vnd.ms-excel',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'text/csv'
          ].includes(value.type)
        ),
      imageZip: yup
        .mixed()
        .nullable()
        .test(
          "fileFormat",
          "Only ZIP files are allowed",
          (value) => !value || value.type.includes('zip') || value.name.endsWith('.zip')
        )
    }),
    onSubmit: async (values, { resetForm }) => {
      setBulkLoading(true);
      try {
        let formData = new FormData();
        formData.append("excelFile", values.excelFile);

        // Only append imageZip if it exists
        if (values.imageZip) {
          formData.append("imageZip", values.imageZip);
        }

        uploadBulkProducts(formData)((response) => {
          if (response?.data?.statusCode === 200) {
            setBulkLoading(false);
            setShow(false);
            resetForm();
            setUpdate(!update);
            toast.success("Products uploaded successfully");
            navigate("/inventory");
          } else {
            setBulkLoading(false);
            toast.error(response?.data?.message || "Upload failed");
          }
        });
      } catch (error) {
        console.error(error);
        toast.error("Something went wrong! Please try again");
        setBulkLoading(false);
      }
    },
  });



  const downloadSampleFile = () => {
    const a = document.createElement("a");
    a.href = sampleFile;
    a.download = `sample-sheet.xlsx`; // Specify the filename here
    document.body.appendChild(a);
    a.click();
  };

  const bulkFormikImage = useFormik({
    initialValues: {
      file: "",
    },
    validationSchema: yup.object().shape({
      file: yup.string("").required("Required"),
    }),
    onSubmit: async (values, { resetForm }) => {
      setLoading(true);
      setBulkLoading(true);
      try {
        let formData = new FormData();
        formData.append("zipFile", values.file);
        // formData.append("manufacturerId", values.manufacturerId);
        uploadBulkImage(formData)((response) => {
          if (response && response?.data?.statusCode == 200) {
            setLoading(false);
            setBulkLoading(false);
            setShow(false);
            resetForm();
            setUpdate(!update);
            toast.success("File Uploaded Successfully");
            navigate("/inventory");
          } else {
            setLoading(false);
            setBulkLoading(false);
            toast.error(response?.data?.message);
          }
        });
      } catch (error) {
        console.error(error);
        toast.error("something went wrong!, please try again", "error");
        setLoading(false);
        setBulkLoading(false);
      }
    },
  });

  const handleBulkFileImageChange = async (e) => {
    const file = e?.target?.files[0];
    bulkFormikImage.setValues({
      ...bulkFormikImage.values,
      file: file,
    });
  }

  const downloadSampleFileImage = () => {
    const a = document.createElement("a");
    a.href = sampleImageFile;
    a.download = `images.zip`; // Specify the filename here
    document.body.appendChild(a);
    a.click();
  };


  const fetchProductsData = async () => {


    const params = filterData
      ? { ...filterData, page, limit, search }
      : { page, limit, search };

    getProductsListing(params)((response) => {
      if (response?.statusCode === 200) {
        setData(response?.data?.products);
        setTotalRows(response?.data?.totalItems);
        setDefaultLoading(false);
      } else {
        setData([]);
        setDefaultLoading(false);
      }
    });
  };

  const fetchOutStockData = async () => {
    const params = filterData
      ? { ...filterData, pageactive, limitactive, search }
      : { pageactive, limitactive, search };
    getProductsOutStockListing(params)((response) => {
      if (response?.statusCode === 200) {
        setActiveData(response?.data?.products);
        setTotalActiveRows(response?.data?.totalItems);
        setLoading(false);
      } else {
        setData([]);
        setLoading(false);
      }
    });
  };

  const fetchProductsLowStockData = async () => {

    const params = filterData
      ? { ...filterData, pageinactive, limitinactive, search }
      : { pageinactive, limitinactive, search };
    getProductsLowStockListing(params)((response) => {
      if (response?.statusCode === 200) {

        setInActiveData(response?.data?.products);
        setTotalInActiveRows(response?.data?.totalItems);
        setLoading(false);
      } else {
        setData([]);
        setLoading(false);
      }
    });
  };
  const handleConfirm = (deletingId) => {
    setModal(!modal);
    setDeletingId(deletingId);
  };

  const deleteProducts = (id) => {
    setLoading(true)
    deleteProduct(id)((response) => {
      if (response?.data?.statusCode == 200) {
        setUpdate(!update);
        setModal(!modal);
        setLoading(false);
        toast.success("Product deleted successfully")
      } else {
        setLoading(false);
        toast.error(response?.data?.message);
      }
    });
  };

  const statusActive = (id) => {
    statusProductUpdate(id)((response) => {
      if (response?.data?.statusCode == 200) {
        setUpdate(!update);
      } else {
      }
    });
  };

  const getStoresDetails = () => {
    getStoresListing()((response) => {
      if (response?.statusCode === 200) {
        setStore(response?.data?.[0]);
      } else {
      }
    });
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setLimit(newPerPage);
    setPage(1);
    setUpdate(!update);
  };

  const handlePerRowsActiveChange = (newPerPage, page) => {
    setLimitActive(newPerPage);
    setPageActive(1);
    setUpdateOutStock(!updateoutstock);
  };

  const handlePerRowsInactiveChange = (newPerPage, page) => {
    setLimitInactive(newPerPage);
    setPageInactive(1);
    setUpdateLowStock(!updatelowstock);
  };

  const handlePerRowsVariantChange = (newPerPage, page) => {
    setLimitVariant(newPerPage);
    setPageVariant(1);
    setUpdate(!update);
  };

  const handlePageChange = (page) => {
    setPage(page);
    setUpdate(!update);
  };

  const handlePageActiveChange = (page) => {
    setPageActive(page);
    setUpdateOutStock(!updateoutstock);
  };

  const handlePageInactiveChange = (page) => {
    setPageInactive(page);
    setUpdateLowStock(!updatelowstock);
  };

  const handlePageVariantChange = (page) => {
    setPageVariant(page);
    setUpdate(!update);
  };

  // const handleFilterChange = (next) => {
  //   setFilter(next);
  //   if (next === "all") {
  //     setPage(1);
  //     setUpdate(u => !u);                 // triggers fetchProductsData
  //   } else if (next === "active") {
  //     setPageActive(1);
  //     setUpdateOutStock(u => !u);         // triggers fetchOutStockData
  //   } else {
  //     setPageInactive(1);
  //     setUpdateLowStock(u => !u);         // triggers fetchProductsLowStockData
  //   }

  // };

  let typingTimer;

  const loadOptionsCategory = inputValue => {
    return new Promise((resolve, reject) => {
      clearTimeout(typingTimer);
      typingTimer = setTimeout(() => {
        if (true) {
          getCategoryListingPaginate({ page: 1, limit: 10, search: inputValue })(response => {
            if (response?.statusCode == 200) {
              resolve(response?.results);
              setCategory(response?.results)
            } else {
            }
          })
        }
        else {
          resolve([]);
          setCategory([])
          setSubCategory([])
        }

      }, 300);
    });
  };

  const loadOptionsSubCategory = inputValue => {
    return new Promise((resolve, reject) => {
      clearTimeout(typingTimer);
      typingTimer = setTimeout(() => {
        const categoryId = searchFormik?.values?.selectedCategory?.value;
        if (categoryId) {
          getSubCategoryListingPaginate({ page: 1, pageSize: 10, search: inputValue, categoryIds: [categoryId] })(response => {
            if (response?.statusCode == 200) {
              resolve(response?.results);
              setSubCategory(response?.results)
            } else {
            }
          })
        }
        else {
          resolve([]);
          setSubCategory([])
        }

      }, 300);
    });
  };

  const fetchBrands = (inputValue, currentPage = 1, limit = 10) => {
    return new Promise((resolve) => {
      clearTimeout(typingTimer); // Clear previous debounce timer
      typingTimer = setTimeout(() => {
        getBrandListing({ pagebrands: currentPage, pageSize: limit, search: inputValue })(response => {
          if (response?.statusCode === 200) {
            const results = response?.data?.map(item => ({
              value: item.id,
              label: item.name,
            }));

            if (currentPage === 1) {
              setBrands(results); // Reset for a new search
            } else {
              setBrands((prevBrands) => [...prevBrands, ...results]); // Append for pagination
            }

            setHasMore(results.length > 0); // Update hasMore based on fetched data
            resolve(results);
          } else {
            setHasMore(false); // No more data
            resolve([]);
          }
        });
      }, 300); // Debounce interval
    });
  };

  const loadOptionsBrands = (inputValue) => {
    return fetchBrands(inputValue, 1); // Always fetch the first page for a new search
  };

  const handleMenuScrollToBottom = () => {
    if (hasMore) {
      const nextPage = page + 1;
      fetchBrands(searchFormik.values.selected_brands?.label || '', nextPage).then(() => {
        setPageBrands(nextPage); // Increment page after fetching
      });
    }
  };

  const fetchManufacturers = (inputValue, currentPage = 1, limit = 10) => {
    return new Promise((resolve) => {
      clearTimeout(typingTimer); // Clear previous debounce timer
      typingTimer = setTimeout(() => {
        getManufacturesListingPaginate({ page: currentPage, limit, search: inputValue })(response => {
          if (response?.statusCode === 200) {
            const results = response?.results?.map(item => ({
              value: item.id,
              label: item.storeName,
            }));

            if (currentPage === 1) {
              setManufacturers(results); // Reset manufacturers for a new search
            } else {
              setManufacturers((prevManufacturers) => [...prevManufacturers, ...results]); // Append for pagination
            }

            setHasMoreManufacture(results.length > 0); // Update `hasMore` based on fetched data
            resolve(results); // Resolve results to AsyncSelect
          } else {
            setHasMoreManufacture(false); // No more data
            resolve([]); // Resolve with an empty array
          }
        });
      }, 300); // Debounce interval
    });
  };

  const loadOptionsManufacture = (inputValue) => {
    return fetchManufacturers(inputValue, 1); // Fetch the first page for a new search
  };

  const handleMenuScrollToBottomManufacture = () => {
    if (hasMoreManufacture) {
      const nextPage = pagemanufacture + 1;
      fetchManufacturers('', nextPage).then(() => {
        setPageManufacture(nextPage); // Increment page after fetching
      });
    }
  };
  const applyFilters = (partial) => {
    const next = { ...searchFormik.values, ...partial };

    // Update UI form state
    searchFormik.setValues(next);

    // Push to recoil (your useEffect listens to filterData)
    setFilterdata(next);

    // UX: reset to first page + show loader
    setPage(1);
    setLoading(true);

    // If you rely on 'update' elsewhere and want to force refresh, uncomment:
    // setUpdate(u => !u);
  };

  const onBrandChange = (selectedOptions) => {
    const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
    applyFilters({
      brands: selectedValues || "",
      selected_brands: selectedOptions || [] || "",
    });
  };

  const onManufactureChange = (selectedOptions) => {
    const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
    applyFilters({
      vendors: selectedValues || "",
      selected_vendors: selectedOptions || [] || "",
    });
  };

  const onCategoryChange = (selectedOption) => {
    applyFilters({
      subCategory: selectedOption ? [selectedOption.value] : [] || "",
      selectedCategory: selectedOption || "",
    });
  };

  const onSubCategoryChange = (selectedOptions) => {
    applyFilters({
      selectedSubCategory: selectedOptions || "",
      subSubCategory: selectedOptions && selectedOptions.length > 0
        ? selectedOptions.map(option => option.value)
        : [] || "",
    });
  };
  const loadStockOptions = (input) =>
    Promise.resolve(
      stockViewOptions.filter(o =>
        o.label.toLowerCase().includes((input || "").toLowerCase())
      )
    );

  const handleStockViewChange = (opt) => {
    const next = opt?.value ?? "all";
    setFilter(next);
    if (next === "all") {
      setPage(1);
      setUpdate((u) => !u);                 // triggers fetchProductsData
    } else if (next === "active") {
      setPageActive(1);
      setUpdateOutStock((u) => !u);         // triggers fetchOutStockData
    } else {
      setPageInactive(1);
      setUpdateLowStock((u) => !u);         // triggers fetchProductsLowStockData
    }
  };




  const handleReset = () => {
    searchFormik.resetForm({
      values: {
        brands: [],
        selected_brands: [],
        vendors: [],
        selected_vendors: [],
        subCategory: [],
        selectedCategory: [],
        subSubCategory: [],
        selectedSubCategory: []
      },
    });
    setFilterdata({
      brands: [],
      selected_brands: [],
      vendors: [],
      selected_vendors: [],
      subCategory: [],
      selectedCategory: [],
      subSubCategory: [],
      selectedSubCategory: []
    });
    setShowOff(false);
    setUpdate(!update);
  };


  useEffect(() => {
    if (searchFormik?.values?.subCategory) {

      getSubCategoryListingPaginate({ page: 1, limit: 10, search: '', categoryIds: searchFormik?.values?.subCategory })(response => {
        if (response?.statusCode == 200) {
          setSubCategory(response?.results)
        } else {
          setSubCategory([])
        }
      })


    }
  }, [searchFormik?.values?.subCategory]);


  useEffect(() => {

    getCategoryListingPaginate({ page: 1, limit: 10, search: '' })(response => {
      if (response?.statusCode == 200) {
        setCategory(response?.results)
      } else {
        setCategory([])
      }
    })

    getManufacturesListingPaginate({ page: 1, limit: 10, search: '' })(response => {
      if (response?.statusCode == 200) {
        setManufacturers(response?.results)
      } else {
      }
    })

    getBrandListing({ page: 1, pageSize: 10, search: '' })(response => {
      if (response?.statusCode == 200) {
        setBrands(response?.data?.map((item, index) => {
          return {
            value: item.id,
            label: item.name
          }

        }))
      } else {
      }
    })


  }, []);

  useEffect(() => {
    setDefaultLoading(true);
    fetchProductsData();
  }, [update, filterData]);

  useEffect(() => {
    setLoading(true);
    fetchOutStockData();
  }, [updateoutstock, filterData]);

  useEffect(() => {
    setLoading(true);
    fetchProductsLowStockData();
  }, [updatelowstock, filterData]);

  useEffect(() => {
    let timeout = setTimeout(() => {
      if (initial) {
        if (filter === "all") {
          setUpdate(!update);
        } else if (filter === "active") {
          setUpdateOutStock(!updateoutstock);
        } else if (filter === "inactive") {
          setUpdateLowStock(!updatelowstock);
        }
      } else {
        setInitial(!initial);
      }
    }, 500);

    return () => {
      clearTimeout(timeout);
    };
  }, [search]);


  const handleRowExpand = (row) => {
    setLoadingNested(true);
    const isRowExpanded = expandedRows.includes(row);
    setExpandedRows(
      [] && isRowExpanded ? expandedRows.filter((r) => r !== row) : [row]
    );
    getProductsVariants({
      productId: row.id,
      page: pagevariant,
      pageSize: limitvariant,
    })((response) => {
      if (response?.statusCode === 200) {
        setVariantData(response?.data?.products);
        setTotalExpandedRows(response?.data?.totalItems);
        setLoadingNested(false);
      } else {
        setVariantData([]);
        setLoadingNested(false);
      }
    });
  };

  const isFilterApplied = !!(
    searchFormik.values.vendors.length > 0 ||
    searchFormik.values.brands.length > 0 ||
    searchFormik.values.subCategory.length > 0 ||
    searchFormik.values.subSubCategory.length > 0
  );


  const customNoOptionsMessage = ({ inputValue }) => {
    return <div>No options</div>;
  };

  const ExpandedComponent = useCallback(() => {
    return (
      <pre>
        <Variant
          variantdata={variantdata}
          loadingnested={loadingnested}
          statusActive={statusActive}
          handleConfirm={handleConfirm}
          handleRowExpand={handleRowExpand}
          checkUserPermissions={checkUserPermissions}
          totalExpandedRows={totalExpandedRows}
          limitvariant={limitvariant}
          pagevariant={pagevariant}
          handlePerRowsVariantChange={handlePerRowsVariantChange}
          handlePageVariantChange={handlePageVariantChange}
        />
      </pre>
    );
  }, [variantdata, loadingnested]);



  return (
    <>
      <div>

        <div className="row">
          <div className="col-12">



            <div className="mb-3">
              {/* Title and Controls Row */}
              <div className="d-flex justify-content-between align-items-center mb-3">
                <div className="d-flex align-items-center">
                  <h3 className="mb-0  fw-bolder">Inventory</h3>
                </div>

                {/* Upper Row - Action Buttons */}
                <div className="action-buttons-row d-flex align-items-center">
                  <Button className="request_btn" onClick={handleShow}>
                    <FaCloudUploadAlt className="icon" />
                    Bulk Inventory Upload
                  </Button>


                  {(user?.userType === "Vendor") && (
                    <Button className="request_btn"
                      onClick={() => navigate("/sync-inventory")}>
                      <FaCloudUploadAlt className="icon" />
                      Smart Inventory
                    </Button>
                  )}

                  {checkUserPermissions("manage_products") ? (
                    <Button
                      className="request_btn"
                      onClick={() => navigate("/create-inventory")}
                    >
                      <FaRegSquarePlus className="icon" />
                      Add New Product
                    </Button>
                  ) : null}
                </div>
              </div>

              <Offcanvas show={showOff} onHide={handleCloseOff} placement='end'>
                <Offcanvas.Header closeButton>
                  <Offcanvas.Title>Filters</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                  <div className="request_wrapper_filter">
                    <Form onSubmit={searchFormik.handleSubmit}>

                      <div className='seperation_filter_reports'>
                        <Form.Group className="mb-3">
                          <Form.Label className='mb-2'>Category</Form.Label>
                          <AsyncSelect
                            loadOptions={loadOptionsCategory}
                            defaultOptions={category}
                            classNamePrefix="select"
                            isClearable={true}
                            placeholder={'Search Categories'}
                            onChange={onCategoryChange}
                            value={searchFormik.values.selectedCategory}
                            noOptionsMessage={customNoOptionsMessage}
                            theme={(theme) => ({
                              ...theme,
                              borderRadius: "0 10px 10px 10px",
                              colors: {
                                ...theme.colors,
                                primary: '#779be1',
                              },
                            })}
                            styles={{
                              menu: (baseStyles) => ({
                                ...baseStyles,
                                zIndex: 9999,
                              }),
                              control: (provided) => ({
                                ...provided,
                                border: " 1px solid #a7a7a7",
                                padding: '6px',
                              }),
                            }}
                          />
                        </Form.Group>

                        <Form.Group className="mb-3">
                          <Form.Label className='mb-2'>Sub-Category</Form.Label>
                          <AsyncSelect
                            isMulti
                            loadOptions={loadOptionsSubCategory}
                            defaultOptions={true}
                            classNamePrefix="select"
                            isClearable={true}
                            placeholder={'Search Sub Categories'}
                            onChange={onSubCategoryChange}
                            value={searchFormik.values.selectedSubCategory}
                            isDisabled={searchFormik.values.selectedCategory === ''}
                            noOptionsMessage={customNoOptionsMessage}
                            theme={(theme) => ({
                              ...theme,
                              borderRadius: "0 10px 10px 10px",
                              colors: {
                                ...theme.colors,
                                primary: '#779be1',
                              },
                            })}
                            styles={{
                              menu: (baseStyles) => ({
                                ...baseStyles,
                                zIndex: 9999,
                              }),
                              control: (provided) => ({
                                ...provided,
                                border: " 1px solid #a7a7a7",
                                padding: '6px',
                              }),
                            }}

                          />
                        </Form.Group>

                        <Form.Group className="mb-3">
                          <Form.Label className='mb-2'>Brands</Form.Label>
                          <AsyncSelect
                            isMulti // Enable multi-select
                            loadOptions={loadOptionsBrands}
                            defaultOptions={brands}
                            classNamePrefix="select"
                            isClearable={true}
                            placeholder="Search Brands"
                            onChange={onBrandChange}
                            value={searchFormik.values.selected_brands}
                            onMenuScrollToBottom={handleMenuScrollToBottom} // Trigger pagination on scroll
                            noOptionsMessage={() => (hasMore ? "Loading more options..." : "No more options")}
                            theme={(theme) => ({
                              ...theme,
                              borderRadius: "0 10px 10px 10px",
                              colors: {
                                ...theme.colors,
                                primary: '#779be1',
                              },
                            })}
                            styles={{
                              menu: (baseStyles) => ({
                                ...baseStyles,
                                zIndex: 9999,
                              }),
                              control: (provided) => ({
                                ...provided,
                                border: "1px solid #a7a7a7",
                                padding: '6px',
                              }),
                            }}
                          />
                        </Form.Group>

                        <Form.Group className="mb-3">
                          <Form.Label className='mb-2'>Vendors</Form.Label>
                          <AsyncSelect
                            isMulti // Enable multi-select
                            loadOptions={loadOptionsManufacture}
                            defaultOptions={manufacturers}
                            classNamePrefix="select"
                            isClearable={true}
                            placeholder="Search Vendors"
                            onChange={onManufactureChange}
                            value={searchFormik.values.selected_vendors}
                            onMenuScrollToBottom={handleMenuScrollToBottomManufacture} // Trigger pagination on scroll
                            noOptionsMessage={() => (hasMoreManufacture ? "Loading more options..." : "No more options")}
                            theme={(theme) => ({
                              ...theme,
                              borderRadius: "0 10px 10px 10px",
                              colors: {
                                ...theme.colors,
                                primary: '#779be1',
                              },
                            })}
                            styles={{
                              menu: (baseStyles) => ({
                                ...baseStyles,
                                zIndex: 9999,
                              }),
                              control: (provided) => ({
                                ...provided,
                                border: "1px solid #a7a7a7",
                                padding: '6px',
                              }),
                            }}
                          />
                        </Form.Group>


                        <div className='btn-groups'>
                          <Button className='search_filter' type='submit'>Search</Button>
                          <Button className='reset_btn_wrapper' onClick={handleReset}>Reset</Button>
                        </div>
                      </div>
                    </Form>

                  </div>
                </Offcanvas.Body>
              </Offcanvas>
            </div>



            <Box
              sx={{
                pb: 3,
                display: "flex",
                flexDirection: "row",
                gap: 2,
                minWidth: "100%",

                // make each field full width on phones, 220px on md+
              }}
            >

              <Form onSubmit={handleShowOff} style={{ width: "100%" }}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "24px", // Adjusted gap for better spacing
                    width: "100%",


                  }}
                >
                  <Box
                    className="filter-field"
                    sx={{
                      flex: "0 0 200px",              // fixed width
                      position: "sticky",
                      left: 0,
                      zIndex: 2,                      // above the scrolling strip
                      backgroundColor: "#fff",        // match page background so it doesn’t show overlap
                    }}
                  >
                    <Form.Group className="filter-field">
                      <Form.Label style={{ fontSize: "12px", fontWeight: 600 }}>Search</Form.Label>
                      <Form.Control
                        type="text"
                        className="form-control"
                        placeholder="search for products ..."
                        onChange={(e) => setSearch(e.target.value.trim())}
                        style={{
                          minHeight: "35px",
                          fontSize: "1vmax",
                          borderRadius: "6px",
                          lineHeight: "2",
                          padding: "2px 8px",
                        }}
                      />
                    </Form.Group>
                  </Box>
                  <Box
                    sx={{
                      flex: "1 1 150px",
                      display: "flex",
                      flexDirection: "row",
                      flexWrap: "nowrap",
                      paddingTop: ".5px",
                      gap: "24px",
                      overflowX: "auto",
                      overflowY: "hidden",
                      // hide scrollbar cross-browser
                      "::-webkit-scrollbar": { display: "none" },
                      msOverflowStyle: "none",
                      scrollbarWidth: "none",

                      // make each field a fixed tile
                      "& .filter-field": {
                        flex: "0 0 150px",
                      },
                    }}
                  >
                    <Form.Group className="filter-field">
                      <Form.Label style={{ fontSize: "12px", fontWeight: 600 }}>Category</Form.Label>
                      <AsyncSelect
                        loadOptions={loadOptionsCategory}
                        defaultOptions={category}
                        classNamePrefix="select"
                        isClearable={true}
                        placeholder={'Select'}
                        onChange={onCategoryChange}
                        value={searchFormik.values.selectedCategory}
                        noOptionsMessage={customNoOptionsMessage}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          control: (base) => ({
                            ...base,
                            minHeight: 30,
                            fontSize: "1vmax"
                          }),
                          input: (base) => ({ ...base, fontSize: "1vmax" }),
                          singleValue: (base) => ({ ...base, fontSize: "1vmax" })
                        }}
                        theme={(t) => ({
                          ...t,
                          spacing: { ...t.spacing, controlHeight: 30, baseUnit: 3 }
                        })}
                      />
                    </Form.Group>
                    <Form.Group className="filter-field">
                      <Form.Label style={{ fontSize: "12px", fontWeight: 600 }}>Sub-Category</Form.Label>
                      <AsyncSelect
                        isMulti
                        loadOptions={loadOptionsSubCategory}
                        defaultOptions={subcategory}
                        classNamePrefix="select"
                        isClearable={true}
                        placeholder={'Select'}
                        onChange={onSubCategoryChange}
                        value={searchFormik.values.selectedSubCategory}
                        noOptionsMessage={customNoOptionsMessage}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          control: (base) => ({
                            ...base,
                            minHeight: 30,
                            fontSize: "1vmax"
                          }),
                          input: (base) => ({ ...base, fontSize: "1vmax" }),
                          singleValue: (base) => ({ ...base, fontSize: "1vmax" })
                        }}
                        theme={(t) => ({
                          ...t,
                          spacing: { ...t.spacing, controlHeight: 30, baseUnit: 3 }
                        })}
                      // styles={customStyles}
                      />
                    </Form.Group>
                    <Form.Group className="filter-field">
                      <Form.Label style={{ fontSize: "12px", fontWeight: 600 }}>Brands</Form.Label>
                      <AsyncSelect
                        isMulti // Enable multi-select
                        loadOptions={loadOptionsBrands}
                        defaultOptions={brands}
                        classNamePrefix="select"
                        isClearable={true}
                        placeholder="Select"
                        onChange={onBrandChange}
                        value={searchFormik.values.selected_brands}
                        onMenuScrollToBottom={handleMenuScrollToBottom} // Trigger pagination on scroll
                        noOptionsMessage={() => (hasMore ? "Loading more options..." : "No more options")}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          control: (base) => ({
                            ...base,
                            minHeight: 30,
                            fontSize: "1vmax"
                          }),
                          input: (base) => ({ ...base, fontSize: "1vmax" }),
                          singleValue: (base) => ({ ...base, fontSize: "1vmax" })
                        }}
                        theme={(t) => ({
                          ...t,
                          spacing: { ...t.spacing, controlHeight: 30, baseUnit: 3 }
                        })}
                      />
                    </Form.Group>
                    <Form.Group className="filter-field">
                      <Form.Label style={{ fontSize: "12px", fontWeight: 600 }}>Vendors</Form.Label>
                      <AsyncSelect
                        isMulti // Enable multi-select
                        loadOptions={loadOptionsManufacture}
                        defaultOptions={manufacturers}
                        classNamePrefix="select"
                        isClearable={true}
                        placeholder="Select"
                        onChange={onManufactureChange}
                        value={searchFormik.values.selected_vendors}
                        onMenuScrollToBottom={handleMenuScrollToBottomManufacture} // Trigger pagination on scroll
                        noOptionsMessage={() => (hasMoreManufacture ? "Loading more options..." : "No more options")}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          control: (base) => ({
                            ...base,
                            minHeight: 30,
                            fontSize: "1vmax"
                          }),
                          input: (base) => ({ ...base, fontSize: "1vmax" }),
                          singleValue: (base) => ({ ...base, fontSize: "1vmax" })
                        }}
                        theme={(t) => ({
                          ...t,
                          spacing: { ...t.spacing, controlHeight: 30, baseUnit: 3 }
                        })}
                      />
                    </Form.Group>
                    <Form.Group className="filter-field">
                      <Form.Label style={{ fontSize: "12px", fontWeight: 600 }}>Stock</Form.Label>
                      <AsyncSelect
                        classNamePrefix="select"

                        cacheOptions
                        isClearable={true}
                        placeholder="Stock"
                        defaultOptions={stockViewOptions}
                        loadOptions={loadStockOptions}
                        value={stockViewOptions.find(o => o.value === filter) || null}
                        onChange={handleStockViewChange}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          control: (base) => ({
                            ...base,
                            minHeight: 30,
                            fontSize: "1vmax"
                          }),
                          input: (base) => ({ ...base, fontSize: "1vmax" }),
                          singleValue: (base) => ({ ...base, fontSize: "1vmax" })
                        }}
                        theme={(t) => ({
                          ...t,
                          spacing: { ...t.spacing, controlHeight: 30, baseUnit: 3 }
                        })}

                      />
                    </Form.Group>
                    <div style={{
                      paddingTop: "25px",
                      height: "40px"
                    }} >
                      <Button variant="outlined" className='cancel_btn' onClick={handleReset}
                        style={{          // keeps text vertically centered
                          fontSize: "12px"
                        }}
                      > Reset
                      </Button>
                    </div>
                  </Box>
                </Box>
              </Form>
            </Box>


            <div className="d_grid_wrapper"></div>
          </div>
          <CustomisedModal
            isOpen={modal}
            customClass={"policy_modal"}
            toggle={toggleModal}
          >
            <h5>Are you sure you want to remove this item?</h5>
            <div className="policy_Agree">
              <Button
                onClick={() => {
                  setModal(!modal);
                }}
                size="lg"
                className="btn_cancel"
              >
                Cancel
              </Button>
              <Button
                size="lg"
                className="btn"
                onClick={() => deleteProducts(deletingId)}
                disabled={loading}
              >
                {loading ? "Loading" : "Delete"}
              </Button>
            </div>
          </CustomisedModal>
          {filter == "all" && (
            <Box className="products-and-options" sx={{ mt: 1 }}>
              <Paper square className='shadow-none border border-blue-grey-200'>
                <div>
                  <DataTable
                    columns={columns}
                    data={data}
                    progressPending={loading || defaultLoading}
                    conditionalRowStyles={conditionalRowStyles}
                    pointerOnHover // Adds cursor pointer on hover
                    highlightOnHover // Adds hover effect
                    paginationRowsPerPageOptions={[10, 50, 100, 150]}
                    progressComponent={
                      <div style={{ height: "60vh" }}>
                        <Loader />
                      </div>
                    }
                    pagination
                    paginationServer
                    paginationTotalRows={totalRows}
                    paginationPerPage={limit}
                    onChangeRowsPerPage={handlePerRowsChange}
                    onChangePage={handlePageChange}
                    currentPage={page}
                    customStyles={queueDatatableCustomStyles}
                    expandableRows
                    expandOnRowClicked={false}
                    onRowExpandToggled={handleRowExpand}
                    expandableRowsComponent={ExpandedComponent}
                    expandableRowsHideExpander
                    onRowClicked={(row) => navigate("/edit-inventory/" + row.id)}
                    expandableRowExpanded={(row) => expandedRows.includes(row)}
                  />
                </div>
              </Paper>
            </Box>
          )}
          {filter == "active" && (
            <Box className="products-and-options" sx={{ mt: 1 }}>
              <Paper square className='shadow-none border border-blue-grey-200'>
                <div>
                  <DataTable
                    columns={columns}
                    data={activedata}
                    progressPending={loading || defaultLoading}
                    progressComponent={
                      <div style={{ height: "60vh" }}>
                        <Loader />
                      </div>
                    }
                    pagination
                    paginationServer
                    pointerOnHover // Adds cursor pointer on hover
                    highlightOnHover // Adds hover effect
                    paginationTotalRows={totalActiveRows}
                    paginationPerPage={limitactive}
                    paginationRowsPerPageOptions={[10, 50, 100, 150]}
                    onChangeRowsPerPage={handlePerRowsActiveChange}
                    onChangePage={handlePageActiveChange}
                    currentPage={pageactive}
                    customStyles={queueDatatableCustomStyles}
                  />
                </div>
              </Paper>
            </Box>
          )}
          {filter == "inactive" && (
            <Box className="products-and-options" sx={{ mt: 1 }}>
              <Paper square className='shadow-none border border-blue-grey-200'>
                <div>
                  <DataTable
                    columns={columns}
                    data={inactivedata}
                    progressPending={loading || defaultLoading}
                    progressComponent={
                      <div style={{ height: "60vh" }}>
                        <Loader />
                      </div>
                    }
                    pagination
                    paginationServer
                    pointerOnHover // Adds cursor pointer on hover
                    highlightOnHover // Adds hover effect
                    paginationTotalRows={totalInActiveRows}
                    paginationPerPage={limitinactive}
                    onChangeRowsPerPage={handlePerRowsInactiveChange}
                    onChangePage={handlePageInactiveChange}
                    paginationRowsPerPageOptions={[10, 50, 100, 150]}
                    currentPage={pageinactive}
                    customStyles={queueDatatableCustomStyles}
                  />
                </div>
              </Paper>
            </Box>
          )}
          {/* Bulk Upload */}
          <Modal
            show={show}
            onHide={handleClose}
            centered
            className="modal_create"
            size="xxl"
          >
            <Modal.Header closeButton className="border-0 pb-20">
              <Modal.Title className="fw-bold">Bulk Inventory Upload</Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-30">
              <div className="modal_content_wrapper">
                {/* Excel File Upload */}
                <div className="mb-4">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h6 className="text-dark mb-0">Upload Product Excel File</h6>
                    <button
                      onClick={downloadSampleFile}
                      className="text-decoration-none bg-transparent border-0 p-0 d-flex align-items-center gap-1"
                    >
                      <IoDownloadOutline className="text-black" size={16} />
                      <span className="text-black" style={{ textDecoration: 'underline' }}>Download Sample</span>
                    </button>
                  </div>
                  <div className="border rounded p-3 bg-light">
                    <Form.Group controlId="formExcelFile">
                      <Form.Control
                        type="file"
                        accept=".xlsx, .xls, .csv"
                        onChange={handleExcelFileChange}
                        isInvalid={bulkFormikProduct.touched.excelFile && bulkFormikProduct.errors.excelFile}
                      />
                      <Form.Control.Feedback type="invalid">
                        {bulkFormikProduct.errors.excelFile}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </div>
                </div>

                {/* Image ZIP Upload */}
                <div className="mb-4">
                  <div className="d-flex justify-content-between align-items-center my-3">
                    <h6 className="text-dark mb-0">Upload Product Images</h6>
                    <button
                      onClick={downloadSampleFileImage}
                      className="text-decoration-none bg-transparent border-0 p-0 d-flex align-items-center gap-1"
                    >
                      <IoDownloadOutline className="text-black" size={16} />
                      <span className="text-black" style={{ textDecoration: 'underline' }}>Download Sample</span>
                    </button>
                  </div>
                  <div className="border rounded p-3 bg-light">
                    <Form.Group controlId="formImageZip">
                      <Form.Control
                        type="file"
                        accept=".zip"
                        onChange={handleImageZipChange}
                        isInvalid={bulkFormikProduct.touched.imageZip && bulkFormikProduct.errors.imageZip}
                      />
                      <Form.Control.Feedback type="invalid">
                        {bulkFormikProduct.errors.imageZip}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </div>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer className="border-0">
              <Button className='cancel_button' variant="outline-secondary" onClick={handleClose}>
                Cancel
              </Button>
              <Button className="request_btn"
                variant="primary"
                onClick={bulkFormikProduct.handleSubmit}
                disabled={!bulkFormikProduct.values.excelFile || bulkLoading}
              >
                {bulkLoading ? (
                  <>
                    <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                    <span className="ms-2">Uploading...</span>
                  </>
                ) : (
                  "Upload Products"
                )}
              </Button>
            </Modal.Footer>
          </Modal>

        </div>
      </div>
    </>
  );
};

export default Inventory;
